<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <!-- 查询 -->
        <div class="content">
            <h2>商户号管理</h2>
            <h3>数据筛选</h3>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="auto">
                    <el-form-item label="商户号名称" prop="name">
                        <el-input v-model="searchForm.name" placeholder="请输入商户号名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商户号" prop="mchId" label-width="60px">
                        <el-input v-model="searchForm.mchId" placeholder="请输入商户号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status" label-width="50px">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
                            <el-option :label="item.dictName" :value="item.dictId"
                                v-for="item in dictionaries.enable_status" :key="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最后更新时间" prop="updatedTimeStart">
                        <el-date-picker style="width: 215px" v-model="applyTime" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="padding-bottom: 10px">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <el-button type="primary" @click="toNewM">添加商户号</el-button>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize"
                    @selection-change="onMultipleSelection" @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog :title="newText" width="640px" append-to-body :visible.sync="dialogFormVisible">
            <el-form :model="newForm" label-width="120px" :rules="rules" ref="ruleForm">
                <el-form-item label="商户号名称" prop="name">
                    <el-input v-model="newForm.name" placeholder="请输入商户号名称"></el-input>
                </el-form-item>
                <el-form-item label="商户号简写" prop="nickname">
                    <el-input v-model="newForm.nickname" placeholder="请输入商户号简写"></el-input>
                </el-form-item>
                <el-form-item label="商户密钥" prop="mchKey">
                    <el-input v-model="newForm.mchKey" placeholder="请输入商户密钥"></el-input>
                </el-form-item>
                <el-form-item label="商户ID" prop="mchId">
                    <el-input v-model="newForm.mchId" placeholder="请输入商户ID"></el-input>
                </el-form-item>
                <el-form-item label="企业私钥" prop="miniPrivateKey">
                    <el-input v-model="newForm.miniPrivateKey" type="textarea" placeholder="请输入企业私钥"></el-input>
                </el-form-item>
                <el-form-item label="证书序列号" prop="mchSerialNo">
                    <el-input v-model="newForm.mchSerialNo" placeholder="请输入证书序列号"></el-input>
                </el-form-item>
                <el-form-item label="操作证书内容" prop="mchAppKey">
                    <el-input v-model="newForm.mchAppKey" type="textarea" placeholder="请输入操作证书内容"></el-input>
                </el-form-item>
                <el-form-item label="APiV3Key" prop="miniApiKey">
                    <el-input v-model="newForm.miniApiKey" placeholder="请输入APiV3Key"></el-input>
                </el-form-item>
                <el-form-item label="是否启用" prop="status">
                    <el-switch v-model="newForm.status" :active-value="1" :inactive-value="2"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="操作记录" width="780px" append-to-body :visible.sync="dialogTableVisible">
            <lb-table v-horizontal-scroll="'always'" :column="cordColumns" :data="cordData" pagination :total="totalNum"
                layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="pageNo" :page-size="pageSize" @size-change="handleCordSizeChange"
                @p-current-change="handleCordCurrentChange">
            </lb-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { throws } from 'assert'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        LbTable
    },
    data() {
        return {
            dataList: {
                list: [
                    { title: '矩阵管理', path: '', type: '0' },
                    { title: '商户号管理', path: '', type: '1' }
                ]
            },
            applyTime: [],
            searchForm: {
                name: '',
                mchId: '',
                status: '',
                updatedTimeStart: '',
                updatedTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            list: [
                {
                    name: '天兰',
                    image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
                },
                {
                    image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
                },
                {
                    image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
                }
            ],
            columns: [
                { label: '商户号名称', prop: 'name', minWidth: '220' },
                { label: '商户号简写', prop: 'nickname', minWidth: '100' },
                { label: '商户号', prop: 'mchId', minWidth: '120' },
                { label: '关联小程序', prop: 'miniAppNames', minWidth: '200' },
                {
                    label: '状态', prop: 'status', minWidth: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p>
                            </div>
                        )
                    }
                },
                { label: '最后更新时间', prop: 'updatedTime', minWidth: '120' },
                {
                    label: '操作',
                    minWidth: '120',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#409EFF;cursor:pointer' onClick={() => { this.toEdit(scope.row.id) }}>编辑</span>
                                <span style='color:#409EFF;cursor:pointer;margin-left:10px' onClick={() => { this.showCord(scope.row.id) }}>操作记录</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            platformList: [],
            selectionGoods: [],
            dialogFormVisible: false,
            newForm: {
                name: '',
                nickname: '',
                mchKey: '',
                mchId: '',
                miniPrivateKey: '',
                mchSerialNo: '',
                mchAppKey: '',
                miniApiKey: '',
                status: 2,
                id: null
            },
            dialogTableVisible: false,
            cordColumns: [
                { label: '状态', prop: 'info', minWidth: '220' },
                { label: '操作人', prop: 'createdByName', minWidth: '100' },
                { label: '操作时间', prop: 'createdTime', width: '200' },
            ],
            cordData: [
                { date: '启用', name: '状态由“已禁用”改为“启用中”', address: '操作人姓名', time: '2022-05-10 12:45:50' }
            ],
            dictionaries: {},
            rules: {
                name: [
                    { required: true, message: '请输入商户号名称', trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: '请输入商户号简写', trigger: 'blur' }
                ],
                mchKey: [
                    { required: true, message: '请输入商户密钥', trigger: 'blur' }
                ],
                mchId: [
                    { required: true, message: '请输入商户号ID', trigger: 'blur' }
                ],
                miniPrivateKey: [
                    { required: true, message: '请输入企业私钥', trigger: 'blur' }
                ],
                mchSerialNo: [
                    { required: true, message: '请输入证书序列号', trigger: 'blur' }
                ],
                mchAppKey: [
                    { required: true, message: '请输入操作证书内容', trigger: 'blur' }
                ],
                miniApiKey: [
                    { required: true, message: '请输入APiV3Key', trigger: 'blur' }
                ],
            },
            newText: '新增商户号',
            pageNo: 1,
            pageSize: 10,
            totalNum: 0
        }
    },
    created() {
        this.goodsPlatforms()
        this.fetchData()
        this.getDictionaries('enable_status')
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'shopApplyDetail') {
            next(vm => {
                vm.fetchData();
            });
        } else {
            next(vm => {
                vm.fetchData();
            });
        }
    },
    methods: {
        handleCordCurrentChange(e) {
            this.pageNo = e;
            this.showCord()
        },
        handleCordSizeChange(e) {
            this.pageNo = 1;
            this.pageSize = e;
            this.showCord()
        },
        toNewM() {
            this.newText = '新增商户号'
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs['ruleForm'].resetFields();
                for (let x in this.newForm) {
                    this.newForm[x] = ''
                    if (x == 'id') {
                        this.newForm[x] = null
                    }
                }
                this.newForm.status = '2'
                console.log(this.newForm)
            })

        },
        toEdit(id) {
            this.newForm.id = id;
            this.newText = '编辑商户号'
            this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                    this.$refs['ruleForm'].resetFields();
                }

            })
            this.axios.get('/ps/platform/mch/getInfo?id=' + this.newForm.id)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.newForm = res.data;
                        this.dialogFormVisible = true;
                    }
                })

        },
        submitForm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.axios.post('/ps/platform/mch/addOrUpdate', this.newForm)
                        .then(res => {
                            console.log(res)
                            if (res.code == 0) {
                                this.searchForm.pageNo = 1
                                this.fetchData()
                                this.dialogFormVisible = false
                                if (this.newText == '新增商户号') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                // this.newText = '新增商户号'
                                // this.$refs['ruleForm'].resetFields();
                            }
                        })
                } else {
                    // alert('error submit!!');
                    return false;
                }
            });
        },
        // 获取字典数据
        getDictionaries(type) {
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                console.log(res)
                this.dictionaries['enable_status'] = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        showCord(id) {
            let data = {
                id: id,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }
            this.axios.post('/ps/platform/mch/updatedRecordsPageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.cordData = res.data.list;
                        this.totalNum = res.data.totalNum;
                    }
                })
            this.dialogTableVisible = true
        },
        fetchData(type) {
            if (type == 'reset') {
                this.searchForm = {}
                this.applyTime = []
                this.searchForm.pageNo = 1
                this.searchForm.pageSize = 10
            }
            if (type == 'search') {
                this.searchForm.pageNo = 1
                this.searchForm.pageSize = 10
            }
            if (this.applyTime) {
                this.searchForm.updatedTimeStart = this.applyTime[0]
                this.searchForm.updatedTimeEnd = this.applyTime[1]
            } else {
                this.searchForm.updatedTimeStart = ''
                this.searchForm.updatedTimeEnd = ''
            }
            this.axios.post('/ps/platform/mch/getMchPageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.list = res.data.list
                        this.page.totalNum = res.data.totalNum
                    }
                })
        },
        onMultipleSelection(val) {
            this.selectionGoods = val
        },
        handleCurrentChange(currentChange) {
            this.searchForm.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.searchForm.pageSize = sizeChange
            this.fetchData()
        },
        goodsPlatforms() {
            const params = {
                userId: null,
                username: null,
                phone: null,
                vipLevel: null,
                categoryIds: null,
                openTimeStart: null,
                openTimeEnd: null,
                status: 1
            }
            this.$api.goodsPlatforms(params).then((res) => {
                this.platformList = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        add() {
            this.$router.push({
                name: 'platListDetail',
                query: {}
            })
        },
        setting() {
            this.$router.push({
                name: 'settingPlatform',
                query: {}
            })
        },
        todetail(row, type) {
            if (type == 'look') {
                this.$router.push({
                    name: 'shopApplyDetail',
                    query: {
                        id: row.id
                    }
                })
            } else {
                this.$router.push({
                    name: 'shopApplyEdit',
                    query: {
                        id: row.id
                    }
                })
            }

        }
    }
}
</script>
  
<style scoped lang="scss">
.container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    padding: 5px;
}

.title {
    display: flex;
    justify-content: space-between;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }
}

.success {
    color: #12AB62;
}

.danger {
    color: #F33F3F;
}
</style>
  
  